module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/career_pass-cb300ab349e42a43a6bdbf4eba73571c.svg";